import { useState } from 'react'

import {
  Box,
  Title,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'
import { Switch } from '@factorialco/f0-react/dist/experimental'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { ClassWizardData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'

export const EmployeeSelectorStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<ClassWizardData>) => {
  useOnNext(() => {
    track(trackingEvents.training.trainingGroupCreationWizard.goToParticipantsNextStep)
  })
  const [showTerminatedEmployees, setShowTerminatedEmployees] = useState(false)
  return (
    <Box gap="s24">
      <Title
        variant="500"
        title={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.title'
        )}
        description={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.description'
        )}
      />
      <EmployeeSelectorV2
        label=""
        multiple
        filters={['jobRole', 'team', 'workplace', 'legalEntity']}
        forcedFilters={{
          includeInactive: showTerminatedEmployees ?? false,
        }}
        onChange={(state) => {
          onDataChanged({
            ...data,
            employeesSelection: state,
          })
        }}
      />
      <Switch
        title={i18n.t(
          'trainings.trainings_revamp.training_class.class_wizard.participants_step.show_terminated_employees'
        )}
        checked={showTerminatedEmployees}
        onCheckedChange={(state) => {
          setShowTerminatedEmployees(!state)
        }}
      />
    </Box>
  )
}
